export default __webpack_public_path__ + "static/muot-69926b1faca6ade69b1869d56828a219.jpeg";